angular.module 'zc.master.zcliteInvoices'

.controller 'MasterZcliteInvoicesListCtrl', (
    $q,
    $scope,
    $translate,
    $filter,
    Page,
    projects,
    SearchFilter,
    ZcsInvoice) ->

  Page.setBodyClass ''
  $translate('masterZclite.invoices.list.liteBillingList').then (translation) ->
    Page.setTitle translation

  $scope.projects = _.chain(projects)
    .filter((p) -> p.product_line == 'zenclerk_s')
    .reject((p) -> p.is_demo || p.is_test)
    # Having neither pricing or conversion_tag means no need to show.
    # In normal flow pricing_confirmed_at is set and initial fee is generated then,
    # but the client might not do conversion_tag_confirmed at same month.
    # For some agencies (such as estore) pricing_confirmed_at won't ever be
    # setup
    .reject((p) -> !p.pricing_confirmed_at && !p.conversion_tag_confirmed_at)
    .value()

  $scope.filteredProjects = []

  $scope.csvHeader = [
    $translate.instant('masterZclite.invoices.list.id'),
    $translate.instant('masterZclite.invoices.list.title'),
    $translate.instant('masterZclite.invoices.list.apikey'),
    $translate.instant('masterZclite.invoices.list.agency'),
    $translate.instant('masterZclite.invoices.list.contractedAt'),
    $translate.instant('masterZclite.invoices.list.terminatedAt'),
    $translate.instant('masterZclite.invoices.list.initialCost'),
    $translate.instant('masterZclite.invoices.list.initialCostDiscount'),
    $translate.instant('masterZclite.invoices.list.minimal'),
    $translate.instant('masterZclite.invoices.list.minimalDiscount'),
    $translate.instant('masterZclite.invoices.list.minimumCharge'),
    $translate.instant('masterZclite.invoices.list.minimumChargeDiscount'),
    $translate.instant('masterZclite.invoices.list.otherExpenses'),
    $translate.instant('masterZclite.invoices.list.otherDiscount'),
    $translate.instant('masterZclite.invoices.list.fixedCost'),
    $translate.instant('masterZclite.invoices.list.campaignDeliveryCosts'),
    $translate.instant('masterZclite.invoices.list.maximumAmount'),
    $translate.instant('masterZclite.invoices.list.fixedRateDiscount'),
    $translate.instant('masterZclite.invoices.list.fixedRateDiscountAmount'),
    $translate.instant('masterZclite.invoices.list.maximumAmountAndFractionalAdjustment'),
    $translate.instant('masterZclite.invoices.list.billedAmountTaxExcluded'),
    $translate.instant('masterZclite.invoices.list.billingAmountTaxIncluded'),
    $translate.instant('masterZclite.invoices.list.agencyPartitionRate'),
    $translate.instant('masterZclite.invoices.list.agencyBilledTaxExcluded'),
  ]

  picked_for_csv = ['id','title','apikey']

  $scope.getCSV = ->
    # this data has orderedHash
    # don't change assignment order.
    csvData = _.map $scope.filteredProjects, (project) ->
      row = _.pick(project, picked_for_csv)
      row.agency = project.agency.title
      row.contracted_at = project.contracted_at
      row.terminated_at = project.terminated_at
      row.initial = $scope.getAdjustmentPrice(project.invoice.adjustments, 'initial')
      row.initial_discount = $scope.getAdjustmentPrice(project.invoice.adjustments, 'initial_discount')
      row.minimal = $scope.getAdjustmentPrice(project.invoice.adjustments, 'minimal')
      row.minimal_discount = $scope.getAdjustmentPrice(project.invoice.adjustments, 'minimal_discount')
      row.minimum_charge = $scope.getAdjustmentPrice(project.invoice.adjustments, 'minimum_charge')
      row.minimum_charge_discount = $scope.getAdjustmentPrice(project.invoice.adjustments, 'minimum_charge_discount')
      row.other = $scope.getAdjustmentPrice(project.invoice.adjustments, 'other')
      row.other_discount = $scope.getAdjustmentPrice(project.invoice.adjustments, 'other_discount')
      row.fixed_invoice_amount = project.fixed_invoice_amount
      row.sum_details_invoice_price = project.invoice.sum_details_invoice_price
      row.max_invoice = project.invoice.max_invoice
      row.discount_percent = project.invoice.discount_percent
      row.percent_discount = project.invoice.percent_discount
      row.rounding_discount = project.invoice.rounding_discount
      row.invoice_price_tax_excluded = project.invoice.invoice_price_tax_excluded
      row.invoice_price = project.invoice.invoice_price
      row.agency_net_interest_rate = _.get(project, 'agency.margin_percent') || null
      row.agency_invoice_price_tax_excluded = $scope.calculateAgencyInvoicePriceTaxExcluded(
        row.agency_net_interest_rate,
        row.invoice_price_tax_excluded,
      )

      return row
    return csvData

  $scope.project_status =
    all: $filter('translate')('masterZclite.invoices.list.all')
    before_trial: $filter('translate')('masterZclite.invoices.list.beforeTrial')
    trial: $filter('translate')('masterZclite.invoices.list.trial')
    terminated_after_trial: $filter('translate')('masterZclite.invoices.list.terminatedAfterTrial')
    contracted: $filter('translate')('masterZclite.invoices.list.contracted')
    terminated_after_contract: $filter('translate')('masterZclite.invoices.list.terminatedAfterContract')

  $scope.totalInvoiceAmount = 0

  maxPeriod = moment().format('YYYY-MM')

  $scope.filters = SearchFilter.resolveFromLocation()
  $scope.filters.agency_name = "all"

  SearchFilter.setComponentDefaults('masterZcliteInvoices', {
    sort_prop:
      default: 'invoice.invoice_price'
    sort_direction:
      default: 'desc'
    agency_name:
      default: 'all'
    search_term: # the free word search
      default: ''
    current_period: # month of search
      default: moment().format('YYYY-MM')
  })

  $scope.$on '$destroy', () ->
    SearchFilter.removeComponentDefaults 'masterZcliteInvoices'

  $scope.nextMonth = () ->
    return if $scope.filters.current_period >= maxPeriod
    $scope.filters.current_period = moment($scope.filters.current_period, 'YYYY-MM').add(1, 'month').format('YYYY-MM')
    $scope.updateData()

  $scope.prevMonth = () ->
    $scope.filters.current_period = moment($scope.filters.current_period, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM')
    $scope.updateData()

  $scope.setSortProp = (key) ->
    if $scope.filters.sort_prop == key
      if $scope.filters.sort_direction == 'desc'
        $scope.filters.sort_direction = 'asc'
      else
        $scope.filters.sort_direction = 'desc'
    else
      $scope.filters.sort_prop = key
      $scope.filters.sort_direction = 'desc'
    $scope.filterProjects()

  $scope.calculateTotal = () ->
    $scope.totalInvoiceAmount = 0
    $scope.totalInvoiceAmountTaxExcluded = 0
    $scope.totalInitialAmount = 0
    $scope.totalMinimalAmount = 0
    $scope.totalFixedAmount = 0
    $scope.totalCampaignAmount = 0
    _.map($scope.filteredProjects, (p) ->
      if p.invoice
        $scope.totalInvoiceAmount += p.invoice.invoice_price
        $scope.totalInvoiceAmountTaxExcluded += p.invoice.invoice_price_tax_excluded
        $scope.totalInitialAmount += $scope.getAdjustmentPrice(p.invoice.adjustments, 'initial')
        $scope.totalInitialAmount += $scope.getAdjustmentPrice(p.invoice.adjustments, 'initial_discount')
        $scope.totalMinimalAmount += $scope.getAdjustmentPrice(p.invoice.adjustments, 'minimal')
        $scope.totalMinimalAmount += $scope.getAdjustmentPrice(p.invoice.adjustments, 'minimal_discount')
        $scope.totalFixedAmount += $scope.getAdjustmentPrice(p.invoice.adjustments, 'fixed')
        $scope.totalCampaignAmount += p.invoice.campaign_invoice_price_after_rounding_discount

    )

  filterByAgency = (projects, agency_name) ->
    _.filter projects, (project) ->
      return true if agency_name == 'all'
      project.agency.name == agency_name

  $scope.filterProjects = () ->
    sortDirectionReverse = ($scope.filters.sort_direction == 'desc')

    $scope.filteredProjects = $filter('projectText')($scope.projects, $scope.filters.search_term)
    $scope.filteredProjects = filterByAgency $scope.filteredProjects, $scope.filters.agency_name
    $scope.filteredProjects = $filter('orderBy')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse)
    $scope.filteredProjects = $filter('emptyToEnd')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse)

    SearchFilter.updateComponentDefaults 'masterZcliteInvoices'
    $scope.calculateTotal()

  $scope.filterProjects()

  $scope.updateData = () ->
    promises = _.map $scope.projects, (p) -> ZcsInvoice.find(p.apikey, $scope.filters.current_period)

    $q.all(promises)
    .then (invoices) ->
      # if there is client without invoice, there will be null result
      # so need to do compact
      invoices = _.compact(invoices)

      $scope.totalInvoicePrice = _.sumBy(invoices, (i) -> i.invoice_price)
      _.each invoices, (i) ->
        project = _.find($scope.projects, (p) -> p.apikey == i.apikey)
        project.invoice = i
        $scope.filterProjects()

  $scope.updateData()

  uniqueAgency = () ->
    $scope.agency_names = []
    uniqued_agency_project = _.uniq $scope.projects, 'agency_id'
    _.map uniqued_agency_project, (p) ->
      $scope.agency_names.push p.agency.name
    $scope.agency_names.unshift 'all'

  uniqueAgency()

  $scope.resetSearchTerm = () ->
    $scope.filters.search_term = ""
    $scope.filterProjects()


  $scope.resetData = () ->
    $scope.filters.agency_name = 'all'
    $scope.filters.search_term = ""
    $scope.filterProjects()

  $scope.getAdjustmentPrice = (adjustments, name) ->
    if name == 'initial'
      # 2016-06 and before data might use old adjustment_type: 'initial' format
      foundAdjustments = _.filter(adjustments, (d) -> d.adjustment_type == 'initial' || d.adjustment_name == 'initial')
    else
      foundAdjustments = _.filter(adjustments, (d) -> d.adjustment_name == name)

    _.sumBy(foundAdjustments, (adjustment) -> adjustment.price) || 0

  $scope.calculateAgencyInvoicePriceTaxExcluded = (agencyNetInterestRate, invoicePriceTaxExcluded) ->
    if !agencyNetInterestRate || agencyNetInterestRate == 1
      return null;

    Math.floor(invoicePriceTaxExcluded * (100 - agencyNetInterestRate) / 100);



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_invoices/list.coffee